<template>
  <div>
  <select-box
      id="operator"
      :options="filteredOptions"
      :disabled="isDisabled"
      v-model="selected"
      :required="required"
      @input="handleInput"
  >
    <translate class="translate">Operátor</translate>
  </select-box>
  </div>
</template>

<script>
export default {
  name: "OperatorSelect",
  props: {
    options: [Array, Object],
    value: [Number, String],
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filteredOptions() {
      let userRoleList = this.$store.getters.getUserRoleList;
      let sectionName = this.$route.meta.sectionName;
      if (sectionName
          && userRoleList.hasOwnProperty(sectionName)
          && userRoleList[sectionName].hasOwnProperty('update')
          && userRoleList[sectionName]['update'] == 'OWN_AND_GLOBAL'
      ) {
        let filteredItems = [];
        for(const item of this.options){
          if(item.id == 0 || item.id == this.$_loggedUser_selectedOperatorId){
            filteredItems.push(item);
          }
        }
        return filteredItems;
      }
      return this.options;
    },
    selected: {
      get() {
        let selected;
        if(this.$_loggedUser_canChangeOperator && this.$store.getters.getSelectedOperatorId && !this.disabled){
          selected = this.$store.getters.getSelectedOperatorId;
        }else {
         selected = this.value;
        }
        this.handleInput(selected);
        return selected;
      },
      set() {
        // declaring setter, but assigning value with onChange method
      }
    },
    isDisabled(){
      if(this.$_loggedUser_canChangeOperator && this.$store.getters.getSelectedOperatorId && !this.disabled){
        return true;
      }else{
        return this.disabled;
      }
    }
  },
  methods: {
    handleInput(value){
      this.$emit('input', value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/OperatorSelect.vue